import { AppEnvironment } from '@f4rm/app-core/models/app-environment';

export const environment: AppEnvironment = {
  production: false,
  config: {
    sentry: {
      dsn: 'https://b010605a18b197e36df24c6dd6bab4aa@o4510555153432576.ingest.us.sentry.io/4510555163852800',
      enabled: true
    },
    firebase: {
      apiKey: 'AIzaSyAmz8Mi0I7uxZ200LeJcI4U-tpV10bQcp4',
      authDomain: 'farmhub-io.firebaseapp.com',
      projectId: 'farmhub-io',
      storageBucket: 'farmhub-io.firebasestorage.app',
      messagingSenderId: '389276187508',
      appId: '1:389276187508:web:6e33933d6c88faf5ab4a21',
      measurementId: 'G-1J1TSGYHM3'
    },
    api: {
      baseUrl: 'https://api.f4rm.dev',
      timeout: 30000
    },
    aiApi: {
      baseUrl: 'https://gateway.f4rm.dev/agent',
      timeout: 30000
    },
    uploadApi: {
      baseUrl: 'https://upload.f4rm.dev',
      timeout: 30000
    },
    websocket: {
      url: 'wss://api.f4rm.dev/ws',
      reconnectInterval: 5000,
      maxReconnectAttempts: 10
    },
    keycloak: {
      url: 'https://identity.f4rm.dev',
      realm: 'f4rm',
      clientId: 'webapp',
      scope: 'openid web-origins profile email gateway roles',
      resourceServerUrls: [
        'https://api.f4rm.dev',
        'https://localhost:3000',
      ],
    },
    googleMaps: {
      apiKey: 'AIzaSyCOaOEr6fcQBd1YLNLjSF2GZRRJopFe_ns'
    }
  },
  logConfig: {
    debugGuards: false,
    debugStores: false,
    debugAuth: false,
    debugWebSocket: false,
    debugApi: false,
    debugForms: true,
    debugTasks: true,
  },
  featureFlags: {
    UI_EXPERIMENT: false,
    ACTIVITY_TRACKING: false,
    GUIDED_TOUR: false,
    FLOATING_ASSISTANT_BUTTON: false,
  },
};
